import { Visibility, VisibilityOff } from '@material-ui/icons'
import { IconButton, InputAdornment, TextField, TextFieldProps } from '@mui/material'
import React, { useState } from 'react'

function TextFieldPassword(props: TextFieldProps) {
  const [showPassword, setShowPassword] = useState(false)

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword)
  }

  return (
    <TextField
      type={showPassword ? 'text' : 'password'}
      {...props}
      InputProps={{
        endAdornment: (
          <InputAdornment position='end'>
            <IconButton aria-label='toggle password visibility' onClick={handleClickShowPassword} edge='end'>
              {showPassword ? <VisibilityOff /> : <Visibility />}
            </IconButton>
          </InputAdornment>
        ),
        sx: {
          '& fieldset': {
            '& legend': {
              display: 'none',
            },
          },
        },
        ...props.InputProps,
      }}
    />
  )
}

export default TextFieldPassword
